<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useSidebar } from './utils'

const props = defineProps<{
	class?: HTMLAttributes['class']
}>()

const { toggleSidebar } = useSidebar()
</script>

<template>
	<ui-button
		data-sidebar="trigger"
		variant="ghost"
		size="icon"
		:class="cn('size-10', props.class)"
		@click="toggleSidebar"
	>
		<i-ph-sidebar-bold class="!size-5" />
		<span class="sr-only">Toggle Sidebar</span>
	</ui-button>
</template>
